<template>
    <div
        class="maxBox"
        ref="main"
        style="height: 100vh; overflow: auto"
        @scroll="handleScroll"
        @click="removeInputState()"
    >
        <div class="topNav">
            <div class="logipt">
                <!-- logo -->
                <div class="logoBox">
                <div class="logo" @click="GoToIndex" style="cursor: pointer" v-if="!isLogin">
                    <img
                    style="width: 100%; height: 100%"
                    src="../../assets/image/logo.png"
                    alt=""
                    />
                </div>
                <div class="logo_title" @click="GoToChangeTab(1)" style="cursor: pointer;" v-if="isLogin">
                    <h1>{{corpTitle}}</h1>
                </div>
                <!-- <router-link to="/searchpage"> -->
                <div
                    class="inputs"
                    style="width: 485px !important; background: #f7f7f7ff"
                >
                    <img src="../../assets/image/search.png" alt="" />
                    <input
                    ref="inputRef"
                    class="ipus"
                    style="
                        color: #999999;
                        outline: none;
                        background: rgb(247, 247, 247);
                        border: none;
                        width: 360px;
                        height: 34px;
                        font-size: 16px;
                    "
                    confirm-type="search"
                    placeholder-class="text"
                    placeholder="书名、作者、关键字"
                    @focus="input_focusIpt"
                    v-on:keyup.enter="input_search(input_content)"
                    v-model="input_content"
                    />
                    <!-- @blur="input_blurIpt" -->
                    <div
                    class="btnBox"
                    style="
                        width: 88px;
                        height: 34px;
                        line-height: 34px;
                        font-size: 16px;
                        background: #e6564eff;
                        color: white;
                        border-radius: 19px;
                        cursor: pointer;
                    "
                    @click="input_search()"
                    >
                    搜索
                    </div>
                </div>
                <div class="showContent" v-if="isInputing2">
                    <div class="titleBg">
                    <div class="title">热门搜索</div>
                    <div class="clear"></div>
                    </div>
                    <div
                    class="item"
                    v-for="(item, index) in hotKeywords"
                    :key="index"
                    @click="input_search(item.title)"
                    >
                    {{ item.title }}
                    </div>
                </div>
                <!-- </router-link> -->
                </div>
                <div v-if="isLogin">
                    <router-link to="/yunbook" 
                    style="display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;">
                        <h3 style="font-size: 18px;color: #2b2b2b;">
                            云书房
                        </h3>
                        <img
                            class="hoveimg"
                            style="width:24px;height:100%; margin:0 0 5px 5px;"
                            src="../../assets/image/lishi.png"
                            alt="" />
                    </router-link>
                </div>
            </div>
            <!-- tab栏 -->
            <div
                class="tablistBg"
                v-if="isShowNav"
                style="height: 70px; box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1)"
            >
            </div>
            <div
                class="tablistBg"
                :class="isShowNav ? 'topNavShow' : ''"
                style="margin-top: 0px"
            >
                <div class="tablist">
                <div
                    class="tab-as"
                    v-for="(item, index) in tabList"
                    :key="index"
                    :class="{ tabActive: item.product_type == num }"
                    @click="GoToChangeTab(item.product_type)"
                    style="color: #333333"
                >
                    {{ item.title }}
                    <span
                    v-if="item.product_type == 11"
                    :class="item.product_type == num ? 'tabActive2' : 'unTabActive2'"
                    style="color: #47cd96;padding-left:5px"
                    >LIVE</span
                    >
                </div>
                </div>
            </div>
        <div class="hovers" ref="hoves">
            <div class="vipmoy">
            <img class="viplo" src="../../assets/image/viplogo.png" alt="" />
            <span class="spanv">[续费VIP]</span>
            </div>
            <div class="names">一直会飞哈哈哈哈哈哈哈哈哈哈</div>
            <div class="times">2021.08.10 到期</div>
            <div class="fenge"></div>
            <div class="fosnam">
            <p>我的订单</p>
            <p>我的卡券</p>
            </div>
            <div class="fonbot">
            <p>物流查询</p>
            <p>我的企业</p>
            <p>关于我们</p>
            <p>作者助手</p>
            </div>
            <div class="nect">退出</div>
        </div>
        </div>
        <div class="ReadingClassify">
            <div class="topbg">
                <h1 class="header-title">分类</h1>
            </div>
            <div class="ereas">
                <div class="left" v-if="initialData.length">
                    <AccordionComponent
                    :initial-data="initialData"
                    @toggle="handleToggle"
                    @content-click="handleContentClick"
                    />
                </div>
                <div class="right">
                    <div class="type">
                        <div class="book-type-container">
                            <div  class="voice voiceActive" type="button">
                                <span v-if="statusType==='eBook'">电子书</span>
                                <span v-if="statusType==='audioBook'">有声书</span>
                                <span v-if="statusType==='course'">课程</span>
                                <span v-if="classifyData.total">({{ classifyData.total }})</span>
                            </div>
                        </div>
                        <div>
                            <button 
                                :class="['filter-button', { 'active': activeFilter === 'new' }]"
                                @click="setActiveFilter('new')"
                            >
                                最新
                            </button>
                            <button 
                                :class="['filter-button', { 'active': activeFilter === 'hot' }]"
                                @click="setActiveFilter('hot')"
                            >
                                最热
                            </button>
                        </div>
                    </div>
                    <div class="book" >
                        <div class="book-item" v-for="item in classifyData.list" :key="item.id">
                            <div class="lefts" @click="setupBackRouterPath(item)">
                                <img :src="prefix + 'ui/draftBook/getCover?multimediaID=' + item.source.logoID||item.source.ID" alt="" @error="handleError" v-if="item.indexType == 'Book' || item.indexType == null">
                                <img v-else :src="item.source.imgUrlCompressed" alt="" @error="handleError" >
                            </div>
                            <div class="right">
                                <h4 class="title" @click="setupBackRouterPath(item)">{{ item.source.title }}</h4>
                                <p>{{ item.source.authors }}</p>
                                <div class="desc" v-html="item.source.summary" v-if="item.source.summary"></div>
                                <div class="desc"  v-else>暂无</div>
                            </div>
                        </div>
                    </div>
                    <!-- <loading-view v-if="classifyData.loading" /> -->
                    <!-- 无更多数据提示 -->
                    <div v-if="classifyData.list.length  === 0" class="no-data">
                        暂无数据
                    </div>
                    <div v-if="noMore && classifyData.list&& classifyData.list.length > 0" class="no-more">
                        已加载全部数据
                    </div>
                </div>
            </div>
        </div>
        <BackTop
        :bottom="300"
        :right="backTopRight"
        style="position: fixed;"
        :class="
            isShowScrollBtn && isShowScrollBtn2
            ? 'showScrollBtn'
            : 'unShowScrollBtn'
        "
        on-click="scrollToTop()"
        >
        <div class="top" @click="scrollToTop">
            <div class="divg">
            <img
                style="width: 100%; height: 100%"
                src="../../assets/image/shang.png"
                alt=""
            />
            </div>
        </div>
        </BackTop>
        <foo-ter class="footer" />
    </div>
</template>

<script>
import apiUrl from "../../js/apiUrl.js";
import fooTer from "../../components/footer";
import AccordionComponent from '@/components/accorDion.vue';
import {classifyAgg, classifyList} from "../../api/bookList.js";
export default {
    name: 'ReadingClassify',
    components: {
        fooTer,
        AccordionComponent
    },
    data() {
        return {
            tabList: [],
            num: 1,
            isShowNav: false,
            input_content: "",
            isInputing2: this.isInputing,
            hotKeywords: [], //热门搜索
            activeFilter: 'new', // 默认选中"最新"
            prefix: this.prefix,
            statusType: '',
            initialData: [],
            classifyData:{
                list:[],
                total:0,
                pageIndex: 0,
                pageSize: 10,
                code:'',
                innerCode:'',
                loading:false
            },
            scrollContainer: null,  // 父组件的滚动容器DOM
            scrollDebounce: null,    // 防抖计时器
            finished: false,
            noMore: false, // 是否无更多数据
            isShowScrollBtn: false,
            backTopRight: 200,
            isShowScrollBtn2: false,
	        corpTitle:''
        }
    },
    props: {},
    created() {
        var that = this;
        that.isLogin = sessionStorage.hasOwnProperty("userLogInInfo");
        if(that.isLogin){
            var userInfo = JSON.parse(sessionStorage.getItem("userLogInInfo"));
            if (userInfo && userInfo.title != '') {
                that.corpTitle = userInfo.title;
            }
        }
        if(this.$route.query.type === 'Book'){
            this.statusType = 'eBook'
        }else if(this.$route.query.type === 'AudioBook'){
            this.statusType = 'audioBook'
        }else if(this.$route.query.type === 'Course'){
            this.statusType = 'course'
        }else{
            this.statusType = ''
        }
        this.num = this.$route.query.num
        if(this.num == 1) {
            document.title = "电子书 - 机工新阅读";
        } else if(this.num == 3) {
            document.title = "有声书 - 机工新阅读";
        } else if(this.num == 4) {
            document.title = "课程 - 机工新阅读";
        }
    },
    mounted() {
        var that = this;
        window.addEventListener("resize", function () {
            that.css_caculateBackTopRight();
        });
        this.setupList();
        this.hotKeywordsGet();
        this.css_caculateBackTopRight();
        this.getClassify();
        this.$nextTick(this.getParentScrollContainer);
    },
    beforeDestroy() {
        if (this.scrollContainer) {
            this.scrollContainer.removeEventListener('scroll', this.handleParentScroll);
        }
        clearTimeout(this.scrollDebounce);
    },

    methods: {
        GoToIndex(){
            if(this.tabList && this.tabList.length>0){
                this.GoToChangeTab(this.tabList[0].product_type)
            }
        },
        css_caculateBackTopRight() {
            var screenWidth = document.body.offsetWidth;
            if (screenWidth < 1200) {
                this.isShowScrollBtn2 = false;
            } else {
                this.isShowScrollBtn2 = true;
            }
            var right = (screenWidth - 1157) / 2 - 30;
            this.backTopRight = right || 200;
        },
        scrollParentToTop() {
            if (!this.$refs.main) return;
            // this.$refs.main.scrollTop = 0;
            this.$refs.main.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
        async getClassify(){
            this.classifyData.loading = true
            try{
                let res = await classifyAgg({type: this.statusType})
                if(res.data.status == 1){
                    let data = this.statusType === 'eBook' ? res.data.data.aggs['xtsflCode'] : res.data.data.aggs['bookClassifyInnerCode'] 
                    let dataList = []
                    if (Array.isArray(data)) {
                        dataList = data.length > 0 ? data : []
                    } else if (data && typeof data === 'object') {
                        dataList = []
                    }
                    let code = ''
                    let innerCode = ''
                    if (this.$route.query.level == 1) {
                        code = this.$route.query.id
                    } else if (this.$route.query.level == 2) {
                        for (let item of dataList) {
                            if (item.children && Array.isArray(item.children)) {
                                for (let child of item.children) {
                                    if (child.code === this.$route.query.id) {
                                        innerCode = child.key
                                        code = item.code
                                        break
                                    }
                                }
                            }
                            if (innerCode) break
                        }
                    } else {
                        code = ''
                        innerCode = ''
                    }

                    this.initialData = dataList.map((item, index) => {
                        // 如果存在 children，给每个 child 设置 isActive 为 false
                        if (item.children && Array.isArray(item.children)) {
                            item.children = item.children.map(child => ({
                                ...child,
                                isActive: innerCode == child.key
                            }));
                        }

                        return {
                            ...item,
                            isExpanded: code == item.code
                        };
                    });

                    this.classifyData.loading = false
                    
                    this.classifyData.code = code
                    this.classifyData.innerCode = innerCode
                    this.getList(code, innerCode)
                }
                    
            }catch(error){
                this.$message.error(error.message);
            }
        },
        async getList(code,innerCode,tab){
            if (this.classifyData.loading || this.noMore) return;
            this.classifyData.loading = true
            
            let params ={
                    pageIndex: this.classifyData.pageIndex,
                    pageSize: this.classifyData.pageSize,
                    type: this.statusType,
                    status: this.activeFilter,
                    code: code || '',
                    innerCode: innerCode || '',
                }
            try{
                let res = await classifyList(params)
                if(res.data.status){
                    this.classifyData.loading = false
                    this.classifyData.list =  [...this.classifyData.list, ...res.data.data.hits] 
                    this.classifyData.total = res.data.data.total
                    this.noMore = this.classifyData.list.length >= this.classifyData.total;
                    if (this.classifyData.list.length >= this.classifyData.total || this.classifyData.total < this.classifyData.pageSize) {
                        this.finished = true
                    }
                }
            }catch(error){
                this.$message.error(error.message);
            }

        },
        handleToggle(data) {
            if(data){
                this.scrollParentToTop()
                this.classifyData.code = data.item.code
                this.classifyData.innerCode = data.item.key
                this.classifyData.list = []
                this.noMore = false
                this.classifyData.pageIndex = '0'
                this.getList(this.classifyData.code, this.classifyData.innerCode)
            }else{
                this.scrollToTop()
                // debugger
                // this.statusType = 'Book'
                // this.classifyData.innerCode = ''
                // this.classifyData.pageIndex = '0'
                // this.getList('','')
            }
        },
        scrollToTop() {
            this.scrollParentToTop();
        },
        handleContentClick(data) {
            console.log('handleContentClick', data)
            this.scrollParentToTop()
            setTimeout(() => {
                this.classifyData.code = data.item.code
                this.classifyData.innerCode = data.child.key
                this.noMore = false
                this.classifyData.list = []
                this.classifyData.pageIndex = '0'
                this.getList(this.classifyData.code,this.classifyData.innerCode)
            },50)
        },
        
        handleTypeChange(type) {
            this.statusType = type;
            console.log('切换书籍类型:', type);
            this.noMore = false
            this.classifyData.list = []
            this.classifyData.pageIndex = '0'
            this.getList(this.classifyData.code,this.classifyData.innerCode,'tab');
        },
        setActiveFilter(filterType) {
            this.activeFilter = filterType;
            this.noMore = false
            this.classifyData.list = []
            this.classifyData.pageIndex = '0'
            this.getList(this.classifyData.code, this.classifyData.innerCode);
        },
        handleError(e){
            // if(this.statusType ==='eBook'||this.statusType ===''){
            //     e.target.src = `${this.imageDomainNew}images/default1.png`
            // }else if(this.statusType ==='AudioBook'||this.statusType==='audioBook'){
            //     e.target.src = `${this.imageDomainNew}images/default2.png`
            // }else if(this.statusType ==='Course'||this.statusType==='course'){
            //     e.target.src = `${this.imageDomainNew}images/default2.png`
            // }
        },
        //跳转·详情
        setupBackRouterPath(item){
            if(this.statusType==='eBook'||this.statusType ===''){
                this.$router.push({
                    path: '/ebookdtl',
                    query: {
                        id: item.source.sourceBookInfoID,
                    }
                })
            }else if(this.statusType==='AudioBook'||this.statusType==='audioBook'){
                this.$router.push({
                    path: '/Audtl',
                    query: {
                        id: item.source.sourceID,
                    }
                })
            }else if(this.statusType==='Course'||this.statusType==='course'){
                this.$router.push({
                    path: '/couraudio',
                    query: {
                        id: item.source.sourceID,
                    }
                })
            }
            
        },
        // 1. 获取父组件的滚动容器DOM
        getParentScrollContainer() {
            this.scrollContainer = this.$refs.main;
            if (!this.scrollContainer) return;
            this.scrollContainer.addEventListener('scroll', this.handleParentScroll);
        },
        handleParentScroll() {
            // 防抖：300ms内只执行一次，避免频繁触发
            clearTimeout(this.scrollDebounce);
            this.scrollDebounce = setTimeout(() => {
                this.checkParentScrollBottom();
            }, 300);
        },
        checkParentScrollBottom() {
            if (!this.scrollContainer) return;
            const { scrollTop, clientHeight, scrollHeight } = this.scrollContainer;
            const threshold = 100;  // 距离底部200px时触发加载
            // 滚动到底部条件：当前滚动位置 + 容器高度 + 阈值 >= 内容总高度
            const isNearBottom = scrollTop + clientHeight + threshold >= scrollHeight;

            // 满足条件且非加载中、有更多数据，触发加载
            if (isNearBottom && !this.classifyData.loading  && !this.noMore) {
                this.classifyData.pageIndex ++
                this.getList(this.classifyData.code,this.classifyData.innerCode);
            }
            let scrollY = scrollTop;
            this.isShowScrollBtn = scrollY ;
        },
        removeInputState() {
            this.isInputing = false;
            this.input_blurIpt();
            this.$forceUpdate();
        },
        hotKeywordsGet() {
            var that = this;
            this.Ajax(apiUrl.search_keywords_get, {}, function(data) {
                if (data && data.length > 0) {
                that.hotKeywords = data;
                }
            });
            },
        input_search(title) {
            if (title && title != "") this.input_content = title;
            this.$refs.inputRef.blur();
            this.isInputing2 = false;
            var url = "/SearchPage";
            var query = { inputStr: this.input_content };
            let routeUrl = this.$router.resolve({
                path: url,
                query: query,
            });
            window.open(routeUrl.href, "_blank");
            this.input_content = "";
        },
        input_focusIpt() {
            setTimeout(() => {
                this.isInputing2 = true;
                this.$refs.inputRef.focus();
                this.$forceUpdate();
            }, 200);
        },
        input_blurIpt() {
            this.isInputing2 = false;
            if (this.$refs.inputRef) {
                this.$refs.inputRef.blur();
            }
        },
        handleScroll(e, item) {
            let scrollY = e.target.scrollTop;
            var height = 90;
            if (scrollY >= height) {
                this.isShowNav = true;
                this.isInputing = false;
                this.input_blurIpt();
            } else {
                this.isShowNav = false;
            }
            this.isShowScrollBtn = scrollY > 200;
            this.$forceUpdate();
        },
        setupList() {
            var that = this;
            this.tabList = [];
            var url = apiUrl.shuyuan_navbar_get;
            var param = { client_type: 2 };
            this.Ajax(url, param, (data) => {
                data.forEach((item) => {
                if (item.product_type == 11) {
                    item.title = "直播";
                }else if (item.product_type == 13) {
                    item.title = "师资";
                }
                if(item.product_type != 11 && item.product_type != 13){
                    that.tabList.push(item);
                }
                });
                // that.tabList.push({
                // title:'院校服务',
                // img_url:'',
                // product_type:15,
                // product_count:0
                // })
                that.productTypeData = data;
            });
            },
    }
}
</script>

<style lang="scss" scoped>
    .top {
        width: 70px;
        height: 70px;
        background: #000000;
        border-radius: 8px;
        opacity: 0.19;
        display: flex;
        align-items: center;
        .divg {
        width: 32px;
        height: 18px;
        margin: 0 auto;
        }
    }
    .topNav {
    width: 100%;
    // height: 173px;
    border: 1px solid #fff;
    background: #fff;
    position: relative;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);

    .hovers {
      width: 221px;
      height: 506px;

      z-index: 20;
      position: absolute;
      right: 290px;
      top: 90px;
      background: #fff;

      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
      display: none;
      .vipmoy {
        width: 180px;
        height: 20px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        margin-top: 14px;
        .viplo {
          width: 34px;
          height: 15px;
        }
        .spanv {
          width: 65px;
          height: 20px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #e6544c;
        }
      }
      .names {
        width: 171px;
        height: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 0 auto;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-top: 8px;
      }
      .times {
        width: 123px;
        height: 20px;
        margin-left: 22px;
        margin-top: 9px;
        font-size: 14px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #999999;
      }
      .fenge {
        width: 179px;
        height: 1px;
        background: #eeeeee;
        margin: 0 auto;
        margin-top: 18px;
        margin-bottom: 18px;
      }
      .fosnam {
        width: 179px;
        height: 100px;
        // border: 1px solid red;
        margin: 0 auto;
        border-bottom: 1px solid #eeeeee;

        p {
          width: 76px;
          height: 25px;
          font-size: 18px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          letter-spacing: 1px;
          margin-top: 20px;
        }
      }
      .fonbot {
        width: 179px;
        height: 190px;
        // border: 1px solid;
        margin: 0 auto;
        border-bottom: 1px solid #eeeeee;
        p {
          width: 76px;
          height: 25px;
          font-size: 18px;
          font-family: PingFang-SC-Medium, PingFang-SC;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          letter-spacing: 1px;
          margin-top: 20px;
        }
      }
      .nect {
        width: 179px;
        height: 57px;
        margin: 0 auto;

        line-height: 57px;

        font-size: 18px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #333333;
      }
    }
    .logipt {
      width: 1157px;
      height: 60px;

      margin: 0 auto;
      margin-top: 27px;
      margin-bottom: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logoBox {
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: relative;

        .logo {
         /*
          width: 360px;
          height: 100%;
          */
         width: 200px;
         margin-top: -17px;
         margin-right: 27px;
        }
		
		.logo_title {
			display: inline-block;
			h1 {
				font-size: 30px;
			}
		}
		
		
        .inputs {
          width: 140px;
          height: 34px;
          background: #f7f7f7;
          border-radius: 25px;
          margin-left: 30px;
          text-align: center;
          font-size: 20px;
          line-height: 50px;
          display: flex;
          align-items: center;
          img {
            width: 17px;
            height: 17px;
            margin-left: 12px;
            margin-right: 12px;
          }
          span {
            font-size: 16px;
            font-family: PingFang-SC-Medium, PingFang-SC;
            font-weight: 500;
            color: #c9c9c9;
          }
        }
        .showContent {
          position: absolute;
          top: 50px;
          left: 320px;
          width: 452px;
          // height: 216px;
          background: white;
          z-index: 99999;
          padding: 18px;
          .titleBg {
            display: flex;
            justify-content: space-between;
            margin-bottom: 3px;
            .title {
              width: 64px;
              height: 22px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #2b2b2b;
              line-height: 22px;
            }
            .clear {
              width: 32px;
              height: 22px;
              font-size: 16px;
              font-family: PingFang-SC-Medium, PingFang-SC;
              font-weight: 500;
              color: #e6564e;
              line-height: 22px;
            }
          }
          .item {
            height: 22px;
            font-size: 16px;
            font-family: PingFang-SC-Medium, PingFang-SC;
            font-weight: 500;
            color: #999999;
            line-height: 22px;
            margin-top: 10px;
            cursor: pointer;
          }
        }
      }
      .logins {
        width: 95px;
        height: 29px;
        font-size: 21px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #e6564e;
      }
      .users {
        width: 210px;
        height: 47px;

        display: flex;
        align-items: center;
        justify-content: space-between;
        div {
          font-size: 21px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #e6564e;
          line-height: 25px;
          width: 130px;
          height: 25px;
          // border: 1px solid red;
          border-right: 3px solid #d8d8d8;
        }
      }
    }
    .tablistBg {
      width: 100%;
      background: white;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .topNavShow {
      position: fixed !important;
      z-index: 99 !important;
      top: 0 !important;
      // left: 0 !important;
      // left: calc((100% - 1157px) / 2) !important;
      background: white;
      margin-top: 0 !important;
      // width: calc(100% - 15px);
      width: 100%;
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    }
    .tablist {
      height: 70px;
      width: 1157px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      align-items: center;
      font-size: 21px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #bdbdbd;
      position: relative;
      margin-top: 0px !important;
      .tabActive {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #e6564e !important;
        padding-bottom: 5px;
        // border: 1px solid red;
        text-align: center;

        display: flex;
        justify-content: center;
      }
      .tab-as {
        text-align: center;
        display: flex;
        justify-content: center;
      }
      .tab-as:hover:before {
        content: "";
        width: 40px;
        border-radius: 5px;
        height: 3px;
        position: absolute;
        text-align: center !important;
        background-color: #e45754;
        display: block;
        bottom: 0;
      }
      .tabActive2 {
        margin-left: 0;
      }
      .unTabActive2 {
        margin-left: -6px;
      }
      .tabActive::before {
        content: "";
        width: 40px;
        border-radius: 5px;
        height: 3px;
        position: absolute;
        text-align: center !important;
        // border-bottom: 4px solid #e6564e;
        background-color: #e45754;
        display: block;
        bottom: 0;
      }
    }
    .tablist:hover {
      cursor: pointer;
    }
  }
.maxBox {
    .showScrollBtn {
        display: block !important;
    }
    .top {
    width: 70px;
    height: 70px;
    background: #000000;
    border-radius: 8px;
    opacity: 0.19;
    display: flex;
    align-items: center;
    .divg {
      width: 32px;
      height: 18px;
      margin: 0 auto;
    }
  }
}
.ReadingClassify{
    
    .topbg {
        width: 100%;
        height: 200px; // 设置顶部背景高度
        margin: 0 auto;
        overflow: hidden; // 隐藏超出部分
        position: relative;
        background: url(../../assets/image/classify.png) no-repeat;
        background-size: 100% 100%;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover; // 保持图片比例，填充容器
            object-position: center; // 图片居中显示
        }
        .header-title{
            max-width: 1200px;
            color: white;
            font-size: 32px;
            font-weight: bold;
            text-align: left;
            position: relative;
            margin: 0 auto;
            padding: 80px 20px;
            padding-bottom: 0;
            &::after {
                content: "";
                position: absolute;
                bottom: 0px;
                left: 0;
                height: 1px;
                width: 8em;
                background-color: #fff;
                border-radius: 10px;
            }
        }

    }
    .ereas {
        width: 100%;
        max-width: 1200px;
        margin: 20px auto;
        display: flex;
        .left {
            flex: 0 0 20%;
            max-width: 20%;
            background-color: #fff; // 左侧背景色
            padding: 20px 10px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            margin-right: 20px;
        }
        .right {
            flex: 1;
            position: relative;
            .type {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .voice {
                    position: relative;
                    display: inline-block;
                    margin-right: 30px;
                    z-index: 1;
                    background: none;
                    border: none;
                    padding: 0;
                    font: inherit;
                    color: inherit;
                    cursor: pointer;
                    font-weight: 500;
                    outline: none;
                    transition: all 0.3s ease;
                }
                
                .voice:hover {
                    opacity: 0.8;
                }
                
                .voice:focus {
                    outline: 2px solid #007bff;
                    outline-offset: 2px;
                }
                .voiceActive:before {
                    z-index: -1;
                    content: "";
                    position: absolute;
                    bottom: 0px;
                    left: -3px;
                    width: 100%;
                    height: 10px;
                    background: linear-gradient(to right, #FFC5BD, #fff);
                }
                .filter-button {
                    padding: 3px 20px;
                    border: none;
                    border-radius: 20px;
                    margin-right: 10px;
                    cursor: pointer;
                    font-size: 14px;
                    transition: all 0.3s ease;
                    outline: none;
                    
                    // 默认状态（未选中）
                    background-color: #dddddd;
                    color: #666666;
                    
                    // 悬停效果（未选中时）
                    &:hover:not(.active) {
                        background-color: #cccccc;
                        color: #333333;
                    }
                    
                    // 选中状态
                    &.active {
                        background-color: #e6564e; // 红色背景
                        color: #ffffff; // 白色字体
                        
                        // 选中状态的悬停效果
                        &:hover {
                            background-color: #d44439; // 稍微深一点的红色
                        }
                    }
                    
                    // 点击效果
                    &:active {
                        transform: scale(0.98);
                    }
                }
                
                // 移除最后一个按钮的右边距
                .filter-button:last-child {
                    margin-right: 0;
                }
            }
            .book {
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                margin-top: 30px;
                gap: 30px;
                .book-item {
                    display: flex;
                    background-color: #fff;
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                    transition: all 0.3s ease;
                    overflow: hidden;
                    
                    &:hover {
                        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
                        transform: translateY(-2px);
                    }
                    
                    .lefts {
                        width: 35%;
                        min-height: 200px;
                        flex-shrink: 0;
                        position: relative;
                        overflow: hidden;
                        border-radius: 12px;
                        cursor: pointer;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            object-position: center;
                            display: block;
                            border-radius: 12px;
                        }
                    }
                    .right {
                        flex: 1;
                        padding: 12px 24px;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        
                        .title {
                            font-size: 18px;
                            font-weight: 500;
                            color: #333;
                            // margin-bottom: 8px;
                            line-height: 1.4;
                            height: 2.8em;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            cursor: pointer;
                        }
                        
                        p {
                            font-size: 14px;
                            color: #666;
                            // margin-bottom: 12px;
                            font-weight: 400;
                            line-height: 1.4;
                            min-height: 2.8em;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                        
                        .desc {
                            flex: 1;
                            font-size: 13px;
                            line-height: 1.6;
                            max-height: calc(6.4em + 14px); // 4行 × 1.6行高 = 6.4em，确保精确显示4行
                            color: #888;
                            background-color: #F7F7F7;
                            border-radius: 8px;
                            padding: 12px;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-line-clamp: 4;
                            -webkit-box-orient: vertical;
                            
                            // 重置内部p标签的样式，避免文字重叠
                            :deep(p) {
                                margin: 0;
                                padding: 0;
                                font-size: inherit;
                                line-height: inherit;
                                color: inherit;
                            }
                        }
                    }
                }
            }
        }
    }

}
// 无更多数据样式
.no-more {
    padding: 15px;
    text-align: center;
    color: #aeaeae;
    font-size: 14px;
    position: relative;
    bottom: -30px;
    width: 100%;
}
.no-data{
        color: #aeaeae;
        position: absolute;
        top:10%;
        left:50%
    }
</style>